/**
 * Curvas topográficas generadas algorítmicamente
 *
 * Generado: 2026-08-04T02:49:17.012Z
 * Total: 16 contours
 *
 * Terreno:
 * - Elevación nordeste (OBJ BRAVO)
 * - Elevación central
 * - Valle con arroyo
 * - Ridge occidental
 */

export const topographicContours = [
  {
    "elevation": 174,
    "path": "M560.3 42.3L501.1 114.0L458.0 190.4L431.0 271.5L416.2 378.6L413.3 511.9L422.7 654.9L444.3 807.6L465.5 905.9L486.2 949.7L510.7 978.7L539.0 993.0L573.6 996.0L614.4 987.7L689.9 960.1L799.9 913.4L872.1 891.7L906.7 895.1L931.0 917.9L945.1 960.3L952.8 1059.5L954.1 1215.5L863.6 971.8L681.1 328.3Z",
    "isMajor": false,
    "area": 246356
  },
  {
    "elevation": 174,
    "path": "M1310.3 150.6L1329.3 152.9L1345.1 162.6L1357.6 179.9L1359.3 216.1L1350.3 271.4L1328.3 325.9L1293.4 379.7L1255.6 415.2L1214.7 432.2L1188.6 428.0L1177.2 402.7L1175.7 367.3L1184.1 321.8L1201.8 274.6L1229.0 225.9L1257.1 188.5L1286.2 162.5L1300.8 149.5L1300.8 149.5Z",
    "isMajor": false,
    "area": 36707
  },
  {
    "elevation": 183,
    "path": "M1043.7 21.7L1010.0 52.2L927.1 94.7L795.1 149.2L704.0 195.2L653.7 232.6L610.0 286.0L572.7 355.3L548.1 438.8L536.0 536.3L535.3 637.0L546.2 741.0L566.5 817.4L596.1 866.1L634.1 891.5L680.7 893.6L759.0 873.9L869.0 832.4L935.9 815.2L959.6 822.1L975.8 841.8L984.4 874.3L991.0 958.8L995.6 1095.3L1011.5 1196.0L1038.7 1261.0L1054.4 971.8L1058.5 328.3Z",
    "isMajor": false,
    "area": 383301
  },
  {
    "elevation": 183,
    "path": "M1279.0 72.6L1310.5 74.7L1340.4 86.8L1368.7 108.7L1389.2 135.3L1402.0 166.4L1406.8 199.9L1403.6 235.6L1392.1 279.5L1372.3 331.5L1347.4 378.6L1317.3 420.9L1278.4 461.1L1230.7 499.4L1189.6 523.4L1155.0 533.2L1132.0 532.0L1120.4 519.7L1112.7 500.5L1108.7 474.5L1112.2 416.0L1123.3 325.0L1146.6 240.5L1181.9 162.5L1215.5 110.5L1247.3 84.5L1263.2 71.5L1263.2 71.5Z",
    "isMajor": false,
    "area": 97248
  },
  {
    "elevation": 192,
    "path": "M1387.7 45.5L1422.1 136.5L1429.7 224.3L1410.7 308.8L1380.7 381.9L1339.8 443.6L1263.0 523.3L1150.4 620.8L1083.3 690.6L1061.9 732.9L1045.5 828.8L1034.3 978.3L1033.4 1074.1L1042.8 1116.4L1057.5 1150.3L1077.4 1175.8L1104.7 1194.7L1139.3 1206.9L1180.1 1212.7L1227.3 1212.0L1304.3 1194.5L1411.1 1160.2L1510.8 1107.6L1603.1 1036.5L1706.8 925.8L1821.9 775.5L1909.3 686.2L1969.0 657.9L2047.6 633.1L2145.0 611.7L1987.9 450.8L1576.3 150.3Z",
    "isMajor": false,
    "area": 648102
  },
  {
    "elevation": 192,
    "path": "M949.5 247.9L987.0 249.8L1015.2 264.4L1034.1 291.8L1044.7 347.8L1046.8 432.3L1040.9 515.1L1026.9 596.4L1007.6 653.3L983.2 685.8L943.8 719.9L889.4 755.6L836.8 783.6L786.0 803.8L743.3 813.2L708.7 811.8L680.7 800.1L659.1 778.0L642.8 744.3L631.6 698.8L626.7 645.1L628.3 583.4L636.4 524.9L651.2 469.6L669.1 424.1L690.2 388.4L715.7 356.5L745.6 328.4L803.1 297.6L888.2 263.9L930.8 247.0L930.8 247.0Z",
    "isMajor": false,
    "area": 188221
  },
  {
    "elevation": 201,
    "path": "M1445.1 53.6L1458.9 160.9L1454.7 256.8L1432.7 341.3L1405.6 408.2L1373.7 457.6L1306.4 532.3L1203.6 632.4L1135.6 715.0L1102.1 780.0L1080.7 861.3L1071.2 958.8L1070.6 1023.8L1078.7 1056.3L1091.8 1083.9L1109.8 1106.6L1150.3 1123.4L1213.1 1134.4L1288.6 1126.0L1376.6 1098.5L1463.9 1050.8L1550.6 982.9L1632.2 890.5L1708.7 773.5L1761.5 700.4L1790.6 671.1L1834.7 644.1L1893.9 619.3L1991.0 594.1L2126.1 568.3L2004.8 416.5L1627.1 138.8Z",
    "isMajor": true,
    "area": 539284
  },
  {
    "elevation": 201,
    "path": "M887.9 382.9L916.2 381.6L939.7 388.7L958.6 404.2L971.6 429.2L978.7 463.7L979.0 502.1L972.3 544.4L948.3 595.3L907.0 655.0L870.6 693.6L839.1 711.1L809.3 720.8L781.0 722.8L755.1 708.6L731.6 678.2L722.0 632.1L726.2 570.4L742.7 514.4L771.4 464.3L807.7 425.3L851.8 397.4L873.8 383.5L873.8 383.5Z",
    "isMajor": true,
    "area": 68142
  },
  {
    "elevation": 210,
    "path": "M1492.2 61.8L1489.4 185.3L1477.1 290.9L1455.2 378.6L1430.5 442.9L1402.9 483.7L1340.9 550.3L1244.4 642.8L1178.1 721.5L1142.2 786.5L1120.0 854.8L1111.6 926.3L1118.2 984.1L1139.6 1028.2L1164.4 1055.3L1192.7 1065.6L1225.7 1069.4L1263.4 1066.8L1324.7 1045.8L1409.6 1006.3L1477.1 961.8L1527.4 912.2L1582.7 833.0L1642.8 724.0L1690.7 653.3L1726.2 620.8L1770.0 596.1L1822.0 579.4L1934.4 557.0L2107.3 528.8L2018.7 386.0L1668.6 128.7Z",
    "isMajor": false,
    "area": 438772
  },
  {
    "elevation": 219,
    "path": "M1543.5 29.3L1527.1 74.8L1510.0 190.8L1492.3 377.4L1472.4 486.1L1450.4 516.9L1395.4 567.3L1307.4 637.2L1246.2 694.2L1211.8 738.4L1184.8 793.0L1165.1 858.0L1157.1 904.0L1160.9 930.9L1169.6 953.6L1183.0 972.2L1201.9 985.6L1226.2 993.7L1254.0 995.7L1285.4 991.7L1335.7 969.2L1404.9 928.4L1459.9 880.5L1500.7 825.3L1538.2 749.4L1572.3 652.8L1600.6 594.0L1623.1 573.1L1774.1 540.9L2053.9 497.4L2033.2 358.4L1712.2 123.8Z",
    "isMajor": false,
    "area": 332063
  },
  {
    "elevation": 228,
    "path": "M1559.5 97.5L1549.2 136.5L1543.9 203.1L1543.4 297.4L1548.1 362.4L1558.0 398.1L1572.7 425.8L1592.2 445.3L1627.3 460.8L1678.1 472.4L1753.7 479.4L1854.3 481.8L1976.9 471.0L2121.4 447.1L2036.4 345.8L1721.9 167.3Z",
    "isMajor": false,
    "area": 140615
  },
  {
    "elevation": 228,
    "path": "M1381.1 669.3L1403.2 668.8L1420.1 675.3L1431.6 688.8L1433.0 721.5L1424.1 773.5L1399.5 820.6L1359.1 862.9L1316.9 887.2L1272.9 893.6L1244.8 885.5L1232.8 862.8L1231.5 833.6L1241.0 797.9L1259.6 762.7L1287.3 728.1L1318.4 700.5L1352.8 679.8L1370.0 669.5L1370.0 669.5Z",
    "isMajor": false,
    "area": 34107
  },
  {
    "elevation": 237,
    "path": "M1589.3 123.5L1577.9 162.5L1573.6 212.9L1576.5 274.6L1585.0 321.8L1599.0 354.3L1619.4 380.7L1646.1 401.0L1689.3 418.6L1749.0 433.6L1819.7 442.8L1901.4 446.0L1973.7 443.4L2036.6 435.0L2099.4 420.0L2162.3 398.5L2044.1 316.7L1744.7 174.9Z",
    "isMajor": true,
    "area": 113484
  },
  {
    "elevation": 246,
    "path": "M1764.4 79.5L1841.1 82.5L1917.4 97.1L1993.3 123.4L2058.2 157.6L2112.1 199.9L2147.2 234.0L2163.7 260.0L2171.5 282.8L2170.8 302.3L2153.8 328.3L2120.4 360.8L2074.3 385.3L2015.6 402.0L1945.4 409.9L1863.7 409.1L1789.9 399.6L1723.9 381.2L1673.6 354.9L1639.0 320.6L1617.8 274.8L1610.1 217.3L1614.8 170.0L1632.0 133.1L1661.9 105.5L1704.6 87.2L1726.0 78.0L1726.0 78.0Z",
    "isMajor": false,
    "area": 151303
  },
  {
    "elevation": 255,
    "path": "M1794.4 112.6L1859.5 116.8L1923.9 131.4L1987.7 156.5L2038.4 186.9L2076.0 222.6L2095.6 258.4L2097.1 294.1L2083.3 323.4L2054.1 346.1L2013.7 362.6L1961.9 372.9L1906.1 375.8L1846.4 371.4L1791.4 360.1L1741.1 342.0L1701.8 318.0L1673.5 288.0L1656.8 253.5L1651.8 214.5L1658.1 180.8L1675.8 152.3L1703.9 131.2L1742.6 117.4L1761.9 110.5L1761.9 110.5Z",
    "isMajor": false,
    "area": 96364
  },
  {
    "elevation": 264,
    "path": "M1792.7 155.1L1837.9 153.2L1884.8 159.7L1933.3 174.6L1973.6 195.0L2005.7 221.0L2023.8 247.0L2027.7 273.0L2021.0 294.1L2003.5 310.4L1978.5 322.6L1946.0 330.7L1890.4 327.7L1811.9 313.6L1760.2 296.5L1735.6 276.5L1719.5 255.1L1711.9 232.4L1712.1 211.3L1720.0 191.8L1735.5 175.5L1758.5 162.5L1770.0 156.0L1770.0 156.0Z",
    "isMajor": false,
    "area": 46459
  }
];

export const elevationLabels = [
  { elevation: 180, x: 450, y: 680 },
  { elevation: 200, x: 1150, y: 780 },
  { elevation: 220, x: 1720, y: 380 }
];
